/* collection-view.js — toggles de visualização da coleção (grade/lista) e de
   imagem (mockup/modelo). Estado vive na URL (?view / ?img). Sem JS o servidor
   já renderiza o default (grade + mockup), que é a degradação desejada.

   Núcleo PURO (readViewState / withViewParams) é testado em Node; o restante é
   cola de DOM, guardada por typeof document. Não toca a zona cortina/zoom. */
(function () {
  'use strict';

  var DEFAULTS = { view: 'grid', img: 'mockup' };

  function normalizeState(state) {
    state = state || {};
    return {
      view: state.view === 'list' ? 'list' : 'grid',
      img: state.img === 'model' ? 'model' : 'mockup'
    };
  }

  // Lê {view, img} de uma query string (com ou sem o "?" inicial).
  function readViewState(search) {
    search = String(search == null ? '' : search);
    var qIdx = search.indexOf('?');
    if (qIdx !== -1) search = search.slice(qIdx + 1);
    var params = new URLSearchParams(search);
    return normalizeState({ view: params.get('view'), img: params.get('img') });
  }

  // Devolve a URL com view/img mesclados: defaults são omitidos (URL limpa),
  // demais params e o hash são preservados, view/img existentes substituídos.
  function withViewParams(url, state) {
    url = String(url == null ? '' : url);
    var hash = '';
    var hashIdx = url.indexOf('#');
    if (hashIdx !== -1) { hash = url.slice(hashIdx); url = url.slice(0, hashIdx); }
    var qIdx = url.indexOf('?');
    var base = qIdx === -1 ? url : url.slice(0, qIdx);
    var query = qIdx === -1 ? '' : url.slice(qIdx + 1);
    var params = new URLSearchParams(query);
    var s = normalizeState(state);
    if (s.view === DEFAULTS.view) { params.delete('view'); } else { params.set('view', s.view); }
    if (s.img === DEFAULTS.img) { params.delete('img'); } else { params.set('img', s.img); }
    var qs = params.toString();
    return base + (qs ? '?' + qs : '') + hash;
  }

  var api = {
    readViewState: readViewState,
    withViewParams: withViewParams,
    normalizeState: normalizeState,
    DEFAULTS: DEFAULTS
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  if (typeof window !== 'undefined') {
    window.SXECollectionView = api;
  }

  // --- Cola de DOM (browser apenas) ---
  if (typeof document === 'undefined') return;

  function init() {
    var bar = document.querySelector('[data-viewbar]');
    var grid = document.querySelector('.shop__grid');
    if (!bar || !grid) return; // só atua na coleção

    bar.setAttribute('data-ready', ''); // progressive enhancement: revela a barra
    var state = readViewState(window.location.search);
    var form = document.getElementById('CollectionFiltersForm');

    function syncGrid() {
      if (state.view === 'list') { grid.setAttribute('data-view', 'list'); }
      else { grid.removeAttribute('data-view'); }
      if (state.img === 'model') { grid.setAttribute('data-img', 'model'); }
      else { grid.removeAttribute('data-img'); }
    }

    function syncButtons() {
      bar.querySelectorAll('[data-set-view]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-set-view') === state.view ? 'true' : 'false');
      });
      bar.querySelectorAll('[data-set-img]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-set-img') === state.img ? 'true' : 'false');
      });
    }

    function syncUrl() {
      var rel = window.location.pathname + window.location.search + window.location.hash;
      try { window.history.replaceState(window.history.state, '', withViewParams(rel, state)); } catch (e) {}
    }

    function syncPagination() {
      document.querySelectorAll('.pagination a[href]').forEach(function (a) {
        a.setAttribute('href', withViewParams(a.getAttribute('href'), state));
      });
    }

    // Garante que filtros/ordenação (form GET) carreguem o estado não-default.
    function ensureHidden(name, value, isDefault) {
      if (!form) return;
      var input = form.querySelector('input[type="hidden"][data-viewparam="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.setAttribute('data-viewparam', name);
        form.appendChild(input);
      }
      input.value = value;
      input.disabled = isDefault; // desabilitado não é enviado -> URL limpa no default
    }

    function syncForm() {
      ensureHidden('view', state.view, state.view === DEFAULTS.view);
      ensureHidden('img', state.img, state.img === DEFAULTS.img);
    }

    function applyAll() {
      syncGrid();
      syncButtons();
      syncUrl();
      syncPagination();
      syncForm();
    }

    bar.addEventListener('click', function (e) {
      var setView = e.target.closest('[data-set-view]');
      var setImg = e.target.closest('[data-set-img]');
      if (setView) {
        state = normalizeState({ view: setView.getAttribute('data-set-view'), img: state.img });
        applyAll();
      } else if (setImg) {
        state = normalizeState({ view: state.view, img: setImg.getAttribute('data-set-img') });
        applyAll();
      }
    });

    applyAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
